export interface CourtDocument {
  id: string
  title: string
  court: string
  caseNumber?: string
  date: string
  type: string
  description?: string
  url?: string
}

export const courtDocuments: CourtDocument[] = [
  {
    id: 'az-motion',
    title: 'State of Arizona — Motion and Order to Dismiss',
    court: 'Superior Court of Arizona, Maricopa County',
    caseNumber: 'Case No. CR2024-115322-001',
    date: 'Filed November 12, 2024',
    type: 'Motion and order',
    url: 'https://cdn.magicpatterns.com/uploads/grNuWUSZUyfHkWqxRfwZWv/States_Motion_to_Dismiss_Callaway.pdf',
  },
  {
    id: 'az-dismissal',
    title: 'Case Dismissal Order',
    court: 'Superior Court of Arizona, Maricopa County',
    caseNumber: 'Case No. CR2024-115322-001',
    date: 'Disposition dated November 15, 2024 · Electronically filed November 18, 2024',
    type: 'Court order',
    url: 'https://cdn.magicpatterns.com/uploads/smNDVS8vrgkeUKDaNKDGmj/20241118_Case_Dismissed.pdf',
  },
  {
    id: 'ca-order',
    title: 'Order Approving Release of Vehicles / Settlement',
    court: 'Superior Court of California, County of San Diego',
    caseNumber: 'Case No. 37-2023-00012636-PR-CP-CTL',
    date: 'Dated November 1, 2025',
    type: 'Court order',
    url: 'https://cdn.magicpatterns.com/uploads/jLZuLaC9wZHbc3fJUd4gcM/Order_Approving_Release_of_Vehicles_Certified.pdf',
  },
  {
    id: 'defense-memo',
    title: 'Defense Memorandum',
    court: 'Submitted on behalf of the defense',
    date: 'August 1, 2024 · Revised final',
    type: 'Memorandum',
    description:
      'Supporting memorandum presenting the defense\u2019s account and legal position concerning the dispute.',
    url: 'https://cdn.magicpatterns.com/uploads/qtim4G4EwD7GjFjW9YGJCR/Callaway.Don.Memo.August.1.2024.REVISED.FINAL.pdf',
  },
]
